import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppConstant } from 'src/app/app.constant';
import { DataResult, DataSourceRequestState } from '@progress/kendo-data-query';


@Injectable({
    providedIn: 'root'
})
export class TaskManagementService {
    apiUrl: string;

    constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl();
    }
    manageTask(task) {
        return this.httpClient.post(`${this.apiUrl}/manageTask`, task).pipe(
            map((response: any) => {
                return response;
            }))
    }
    getTaskById(Id) {
        return this.httpClient.get(`${this.apiUrl}/getTaskById/` + Id).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    updateTaskStatus(task) {
        return this.httpClient.post(`${this.apiUrl}/updateTaskStatus`, task).pipe(
            map((response: any) => {
                return response;
            }))
    }
    createTaskType(type) {
        return this.httpClient.post(`${this.apiUrl}/manageTaskType`, type).pipe(
            map((response: any) => {
                return response;
            }))
    }
    getTaskTypeById(Id) {
        return this.httpClient.post(`${this.apiUrl}/getTaskTypeById/`, Id).pipe(
            map((response: any) => {
                return response;
            }))
    }

    deleteTask(id: number, userId: number) {
        return this.httpClient.delete(`${this.apiUrl}/deleteTask/` + id + '/app/' + userId).pipe(
            map(data => data));
    }

    getAllTasks(branchId: number) {
        return this.httpClient.get(`${this.apiUrl}/getAllTask/` + branchId).pipe(
            map((response: any) => {
                var data = response.data
                return {
                    data: data,
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }

    getAllAssignedTask(state: DataSourceRequestState): Observable<DataResult> {
        let params = {
            state: state
        }
        return this.httpClient.post(`${this.apiUrl}/getAllTaskByUser/`, params).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    // workflow status get API
    public getWorkFlowStatusByEntity(entityName: string) {

        return this.httpClient.get(`${this.apiUrl}/getWorkFlowStatusByEntity/` + entityName).pipe(
            map((response: any) => {
                return response.data
            })
        )
    }

    async getWorkFlowStatusByEntityAsync(entityName: string): Promise<any[]> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getWorkFlowStatusByEntity/` + entityName).toPromise()).data;
    }
    getAllTaskByUser(state: DataSourceRequestState): Observable<DataResult> {
        let params = {
            state: state,
        }
        return this.httpClient.post(`${this.apiUrl}/getAllTaskByUser`, state).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    getAllTask(state: DataSourceRequestState): Observable<DataResult> {
        let params = {
            state: state,
        }
        return this.httpClient.post(`${this.apiUrl}/getAllTask`, params).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    getAllTaskExcel(state: DataSourceRequestState) {
        let params = {
            state: state,
        }
        return new Promise((resolve, reject) => {
            this.httpClient.post(`${this.apiUrl}/getAllTask`, params).map(res => res)
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }

    deleteTaskType(taskTypes) {
        return this.httpClient.post(`${this.apiUrl}/deleteTaskTypes`, taskTypes).pipe(
            map((response: any) => {
                return response;
            }))
    }

    getAllUserRoles() {
        return this.httpClient.get(`${this.apiUrl}/getUserRoles/`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>;
    }

    async getAllTaskType(): Promise<any[]> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getAllTaskType/`).toPromise()).data;
    }
    getAllTaskTypeByBranchId(branchId: number) {
        return this.httpClient.get(`${this.apiUrl}/taskTypeListByBranchId/` + branchId).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>;
    }
    getAllTaskTypeAndAssigneeListAndTaskStatus(assigneeType: number, branchId: number) {
        return this.httpClient.get(`${this.apiUrl}/taskTypeAndAsigneeList/` + assigneeType + '/app/' + branchId).pipe(
            map((response: any) => {
                var data = response
                return {
                    taskTypeList: data.taskTypeList,
                    assigneeList: data.assigneeList,
                    statusList: data.statusList
                }
            })
        ) as any as Observable<any>;
    }
    getAllCreatedTaskExcel(reporter: number, branchId: number) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/createdTaskListExcel/` + reporter + '/app/' + branchId).map(res => res)
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }
    getAllAssignedTaskExcel(assignee: number) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/assignedTaskListExcel/` + assignee).map(res => res)
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }

}
